
<div class="container-fluid p-0 login-Container">
        <div class="XeniusLogo" [ngClass]="{'logo-disappear':  isDisappearing,'no-animation': !hasInitialized}" *ngIf="showitem">
        </div>
        <div class="bulb" [ngClass]="{'bulb-disappear':  isDisappearing,'no-animation': !hasInitialized}">
        </div>
                <div class="login-card" [ngClass]="{'main-shrink':  isDisappearing,'no-animation': !hasInitialized}">
                    <div class="login-main position-relative">
                        <!-- Loading Overlay -->
                        <div class="login-loading-overlay" *ngIf="isLoggingIn">
                            <div class="login-loading-content">
                                <img src="assets/images/loader/XE.gif" alt="Logging in..." width="70" height="70">
                                <p class="login-loading-text">{{ loggingInText }}</p>
                                <div class="login-loading-bar"></div>
                            </div>
                        </div>
                        <form class="theme-form" [formGroup]="loginForm" [ngClass]="{'form-disappear':  isDisappearing,'no-animation': !hasInitialized}">
                            <p class="h3">Login</p>
                            <div class="form-group">
                                <img class="usernameimage" src="\assets\fonts\flag-icon\Person.svg" alt="Person" width="24" height="24">
                                <input class="form-control" type="text" required="" placeholder="Username" 
                                autocomplete="off"
                                    formControlName="Username">
                                @if(loginForm.controls['Username'].touched &&
                                loginForm.controls['Username'].errors?.['required']){
                                <div class="text mt-1" style="color: #f6b53e;font-weight: 600;"> Username is required</div>
                                }
                                @if(loginForm.controls['Username'].touched &&
                                loginForm.controls['Username'].errors?.['Username']){
                                <div class="text mt-1" style="color: #f6b53e;font-weight: 600;">Invalid Username</div>
                                }
                            </div>
                            <div class="form-group">
                                <div class="form-input position-relative">
                                    <span class="passwordimage" (click)="showPassword()" *ngIf="show">
                                        <img  src="\assets\fonts\flag-icon\Eye.svg" alt="Eye" width="24" height="24">
                                    </span>
                                    <span class="passwordimage" (click)="showPassword()" *ngIf="!show">
                                        <img src="\assets\fonts\flag-icon\eyeO.svg" alt="Eye" width="24" height="24">
                                    </span>
                                    <input class="form-control" [type]="show ? 'text' : 'password'" type="password"
                                        name="login[password]" required="" placeholder="Password"
                                        autocomplete="off"
                                        formControlName="password">
                                    @if(loginForm.controls['password'].touched &&
                                    loginForm.controls['password'].errors?.['required']){
                                    <div class="text mt-1" style="color: #f6b53e;font-weight: 600;">Password is required </div>
                                    }
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <div class="checkbox" style="padding: 0 10px 0 10px;">
                                    <input 
                                    id="checkbox1" 
                                    type="checkbox" 
                                    [(ngModel)]="rememberMe" 
                                    [ngModelOptions]="{ standalone: true }"
                                    >
                                    <label for="checkbox1">Remember Me</label>
                                </div>
                                
                                
                                <!-- <a class="link" [routerLink]="['/auth/forgot-password']">Forgot
                                    password?</a> -->
                                <div class="text-end mt-3">
                                    <button class="btn w-100" [disabled]="!loginForm.valid || isLoggingIn"
                                        (click)="login()" type="submit">
                                        <span *ngIf="!isLoggingIn">Login</span>
                                        <span *ngIf="isLoggingIn">Logging in...</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
        <div class="contactus" [ngClass]="{'contact-disappear':  isDisappearing,'no-animation': !hasInitialized}">
            <h5>Contact Us</h5>
            <p>
                <img src="\assets\fonts\flag-icon\Phone.svg" alt="Phone Icon" width="16" height="16"> +91 120 4201765, 7303093408, 8800494881</p>
            <p>
                <img src="\assets\fonts\flag-icon\mail.svg" alt="Phone Icon" width="16" height="16"> info&#64;xenius.in, crm&#64;radius.co.in</p>
            <p>
                <img src="\assets\fonts\flag-icon\House.svg" alt="Phone Icon" width="16" height="16"> H-98, Sector 63, Noida, Uttar Pradesh 201301</p>
        </div>
        <div class="disclaimer" [ngClass]="{'disclaimer-disappear':  isDisappearing,'no-animation': !hasInitialized}">
                <!-- <h5>Terms & Conditions | Disclaimer | Cookie Policy | Privacy Policy</h5> -->
                <p>Copyright © {{currentYear}} Radius Synergies International Pvt. Ltd. | All Rights Reserved</p>
        </div>
        <div
        class="box"
        [ngClass]="{
            'contact-disappear': isDisappearing || removeBox,
            'no-animation': !hasInitialized
        }"
        style="display: flex; align-items: end; justify-content: end;"
        >
                <img src="assets/images/login/disclaimerImage.png" alt="" height="180px;">
        </div>
</div>